import { render, staticRenderFns } from "./CustomerFiles.vue?vue&type=template&id=ac6d37d6&scoped=true&"
import script from "./CustomerFiles.vue?vue&type=script&lang=js&"
export * from "./CustomerFiles.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFiles.vue?vue&type=style&index=0&id=ac6d37d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6d37d6",
  null
  
)

export default component.exports